module.exports = __webpack_public_path__ + "static/media/old-edge_server.a224e9ce.svg";